import type { ServiceLine } from 'api/types/service.types';
import { BUTTON_NAMES } from 'constant/button-names';
import { selectSelectedServices } from 'pages/newOrder/newOrder.selectors';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';

import {
  IconMapper,
  StyledAddButton,
  StyledAddIcon,
  StyledDivRow,
  Styledh3,
  StyledIconContainer,
  StyledIconWrapper,
  StyledItem,
  StyledText,
} from './SelectService.styles';

interface ServiceItemProps {
  name: string;
  service: ServiceLine;
  onCick?: () => void;
  onPressPricing?: (serviceLine: ServiceLine) => void;
}

const ServiceItem = ({ name, service, onCick, onPressPricing }: ServiceItemProps) => {
  const isSelected = useSelector(selectSelectedServices).includes(service);
  const { t } = useTranslation();
  const theme = useTheme();

  const onClickPricing = useCallback(() => {
    if (onPressPricing) {
      onPressPricing(service);
    }
  }, [onPressPricing, service]);

  return (
    <StyledItem className="border-bottom-0">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <StyledIconContainer className="icon">{IconMapper.get(service)?.icon}</StyledIconContainer>
          <div className="margin-start-4">
            <Styledh3 className="mb-1">{name}</Styledh3>
            <StyledText onClick={onClickPricing} className="mb-0">
              View Pricing
            </StyledText>
          </div>
        </div>
        <StyledAddButton buttonName={BUTTON_NAMES.SERVICE_ADD} onClick={onCick} selected={isSelected}>
          <StyledDivRow>
            {theme.components.selectService.serviceItem.addButton.showIcon && !isSelected && (
              <StyledIconWrapper className="margin-start-auto d-flex justify-content-center align-items-center">
                <StyledAddIcon />
              </StyledIconWrapper>
            )}
            <div>{isSelected ? t('common.AddedText', 'Added') : t('common.Add', 'Add')}</div>
          </StyledDivRow>
        </StyledAddButton>
      </div>
    </StyledItem>
  );
};

export default ServiceItem;
